import { ChevronRightLarge as IconComponent } from '@adobe/react-spectrum-ui/dist/ChevronRightLarge.js';
import { UIIcon } from '@adobe/react-spectrum/private/icon/UIIcon';
import React from 'react';
export default function ChevronRightLarge(props) {
  return /*#__PURE__*/React.createElement(UIIcon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}